<template>
  <div>
    <div class="page_title">患者信息列表</div>
    <div style="padding:20px;">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
      >
        <el-menu-item
          index="1"
          style="font-size:16px"
        >正常</el-menu-item>
        <el-menu-item
          index="2"
          style="font-size:16px"
        >已删除</el-menu-item>
      </el-menu>
      <div class="container mytable">
        <div class="searchbox">
          <div style="text-align:left;margin-bottom:10px">
            <span>患者姓名</span>
            <el-input
              v-model="real_name"
              style="width:135px;margin:0 15px 0 10px"
              @input="search"
              clearable
            ></el-input>
            <span>性别</span>
            <el-radio-group
              v-model="sex"
              @change="changeList"
              style="margin:0 15px 0 8px"
            >
              <el-radio :label="0">全部</el-radio>
              <el-radio :label="1">男</el-radio>
              <el-radio :label="2">女</el-radio>
            </el-radio-group>
            <span>所在省市</span>
            <el-select
              v-model="province_id"
              placeholder="请选择"
              @change="search"
              style="width:140px;margin:0 10px"
              clearable
            >
              <el-option
                v-for="item in proList"
                :key="item.province_id"
                :label="item.name"
                :value="item.province_id"
              ></el-option>
            </el-select>
            <span>添加日期</span>
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width:225px;margin:0 10px"
              @change="search"
            ></el-date-picker>
            <el-button
              plain
              style="margin-left:10px;background:#ececec"
              @click="search"
            >查询</el-button>
          </div>
        </div>

        <div style="border:solid 1px #c9cbd6">
          <el-table
            :data="tableData"
            style="width: 100%;min-width:1000px;"
            :header-cell-style="{background:'#F7f8fa'}"
            :default-expand-all="true"
          >
            <el-table-column
              label="添加时间"
              prop="create_time"
            ></el-table-column>
            <el-table-column
              label="患者姓名"
              prop="real_name"
            ></el-table-column>
            <el-table-column label="性别">
              <template slot-scope="scope">
                <span v-if="scope.row.sex==1">男</span>
                <span v-if="scope.row.sex==2">女</span>
                <span v-if="scope.row.sex==0">未知</span>
              </template>
            </el-table-column>
            <el-table-column
              label="年龄"
              prop="age"
            ></el-table-column>
            <el-table-column
              label="所在省市"
              prop="province_name"
            ></el-table-column>
            <el-table-column label="关系（是用户的）">
              <template slot-scope="scope">
                <span v-if="scope.row.relationship==1">本人</span>
                <span v-if="scope.row.relationship==2">爸爸</span>
                <span v-if="scope.row.relationship==3">妈妈</span>
                <span v-if="scope.row.relationship==4">老公</span>
                <span v-if="scope.row.relationship==5">老婆</span>
                <span v-if="scope.row.relationship==6">女儿</span>
                <span v-if="scope.row.relationship==7">儿子</span>
                <span v-if="scope.row.relationship==8">朋友</span>
                <span v-if="scope.row.relationship==9">家人</span>
              </template>
            </el-table-column>
            <el-table-column
              label="问诊记录"
              prop="consult_count"
            ></el-table-column>
            <el-table-column
              label="处方记录"
              prop="prescription_count"
            ></el-table-column>
            <el-table-column
              label="病历记录"
              prop="casehistory_count"
            ></el-table-column>

            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="toPatientDetail(scope.row.patient_id,scope.row.user_id)"
                  :disabled="module_id_array[0]?!module_id_array.includes('41'):false"
                >详情</el-button>
                <!-- <span style="margin-left:10px;color:#669961">
                  测试
                  <el-switch
                    v-model="scope.row.is_test"
                    active-color="#669961"
                    @change="(value)=>{
                    return  setTest(value,scope.row.patient_id)
                  }"
                  ></el-switch>
                </span>-->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin:20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import platform from '../../../api/platform';
import patient from '../../../api/patient';
import dayjs from 'dayjs';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      activeIndex: '1',
      is_delete: 1,
      real_name: '',
      province_id: '',
      proList: [],
      is_bind: 0,
      sex: 0,
      date: []
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    admin_id() {
      return this.$store.state.login.userInfo.admin_id;
    }
  },
  methods: {
    handleSelect(key) {
      this.province_id = '';
      this.sex = 0;
      this.real_name = '';
      this.currentPage = 1;
      this.pagesize = 10;
      this.is_delete = key;
      this.date = [];
      this.getList();
    },
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        real_name: this.real_name,
        sex: this.sex,
        province_id: this.province_id,
        is_delete: this.is_delete
      };
      if (this.date && this.date.length > 0) {
        data.start_time = dayjs(this.date[0]).format('YYYY-MM-DD');
        data.end_time = dayjs(this.date[1]).format('YYYY-MM-DD');
      }
      this.axios
        .post('platform/patient/patientListNew', data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.create_time = dayjs
                .unix(item.create_time)
                .format('YYYY-MM-DD HH:mm:ss');
              // item.is_test = item.is_test == 1 ? true : false;
              return item;
            });
            this.totalNum = res.data.total;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //获取省市列表
    getProvince() {
      this.axios
        .post('platform/platform/getProvinceCityDistrict')
        .then((res) => {
          this.proList = res.data.list;
        });
    },
    //设置测试账号
    setTest(value, user_id) {
      let text = '';
      let status = '';
      if (value) {
        text = '确定将该账号设置为测试账号？';
        status = 1;
      } else {
        text = '确定取消测试账号？';
        status = 2;
      }

      this.$confirm(text, '提示消息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          patient.setTestUser({ user_id, status }).then((res) => {
            if (res.code == 0) {
              this.$message.success('设置成功');
              this.getList();
            }
          });
        })
        .catch(() => {
          this.getList();
        });
    },
    //筛选状态
    changeList() {
      this.currentPage = 1;
      this.getList();
    },

    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },

    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    // //用户详情
    // toUserDetail(user_id) {
    //   this.$router.push({
    //     path: "userdetail",
    //     query: {
    //       user_id
    //     }
    //   });
    // },
    //患者详情
    toPatientDetail(patient_id, user_id) {
      this.$router.push({
        path: 'patientdetail',
        query: {
          patient_id,
          user_id
        }
      });
    },
    //审核
    examine(reviewed_id) {
      this.$confirm('是否审核通过？', '审核', {
        closeOnClickModal: false,
        distinguishCancelAndClose: true,
        confirmButtonText: '通过',
        cancelButtonText: '不通过'
      })
        .then(() => {
          let auth_status = 3;
          doctor.auditDoctor({ reviewed_id, auth_status }).then((res) => {
            if (res.code == 0) {
              this.$message.success('该医生审核通过!');
            }
            this.getList();
          });
        })
        .catch((action) => {
          if (action === 'cancel') {
            let auth_status = 4;
            doctor.auditDoctor({ reviewed_id, auth_status }).then((res) => {
              if (res.code == 0) {
                this.$message.error('该医生审核未通过!');
              }
              this.getList();
            });
          }
        });
    },
    //批量审核
    examineAll() {
      if (!this.Selection.length) {
        this.$message.error("请勾选'审核中'的记录");
        return false;
      }
      let selectId = this.Selection.map((item) => {
        return item.reviewed_id;
      });
      let reviewed_id = selectId.toString();
      this.examine(reviewed_id);
    }
  },
  created() {
    if (this.$route.params.doctor_name) {
      this.doctorName = this.$route.params.doctor_name;
      this.doctorPhone = this.$route.params.phone;
    }
    this.getProvince();
  },
  activated() {
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  border-radius: 5px;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.text_over {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  width: 80px;
  text-overflow: ellipsis;
}
.name_over {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  width: 120px;
  text-overflow: ellipsis;
}
</style>



